import { ChevronDown } from "lucide-react";
import React, { SyntheticEvent } from "react";

import { Autocomplete, AutocompleteProps } from "@mui/material";

type SimpleAutocompleteProps = Omit<
  AutocompleteProps<any, any, any, any>,
  "options" | "onChange" | "getOptionLabel"
> & {
  options: readonly any[];
  onChange?: (
    event: SyntheticEvent,
    value: any,
    reason?: any,
    details?: any
  ) => void;
  getOptionLabel?: (option: any) => string;
}; // intentionally broad for backward compatibility

export const IgAutocomplete = (props: SimpleAutocompleteProps) => {
  return (
    <Autocomplete<any, any, any, any>
      {...props}
      popupIcon={props.popupIcon ?? <ChevronDown size={16} />}
    />
  );
};
